<template>
<footer>
  <h1>Footer One</h1>
</footer>
</template>

<script lang="ts">
import { defineNuxtComponent, navigateTo } from '#app';
import { mapState } from 'pinia';
import { ComponentMixin } from '~/mixins/component.mixin';
import { useWebsiteStore } from '~/units/website/store';

interface MenuItem {
  name: string;
  url: string;
  has_sub_menu: boolean;
  is_open_new_tab: boolean;
  sub_menus?: MenuItem[];
}

export default defineNuxtComponent({
  name: 'RochfordStokesFooter',
  mixins: [ComponentMixin],

  data() {
    return {
      menuVisible: false,
      isScrolled: false,
      openSubMenu: null as number | null,
    };
  },

  computed: {
    redress() {
      return this.groupedVariables.redress;
    },
    cards() {
      return this.groupedVariables.cards;
    },
    ...mapState(useWebsiteStore, ['company', 'headerMenuItems']),

    logo(): string {
      const currentCompany = this.company as any;
      const defaultLogo = currentCompany?.logo || '';
      // Hiçbir koşul olmaksızın sadece default logo dönsün.
      return defaultLogo;
    },

    footerMenuItems(): MenuItem[] {
      // headerMenuItems'ı footer için kullanıyorsan burayı düzenleyebilirsin
      return (this.headerMenuItems as MenuItem[]) || [];
    },
  },

  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    this.handleScroll();
  },

  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },

  methods: {
    handleScroll(): void {
      this.isScrolled = window.scrollY > 50;
    },

    toggleSubMenu(index: number): void {
      // Açık olan alt menüyü tekrar tıklarsan kapatır, değilse açar
      this.openSubMenu = this.openSubMenu === index ? null : index;
    },

    handleMenuLinkClick(menuItem: MenuItem): void {
      if (!menuItem || menuItem.has_sub_menu || !menuItem.url) return;
      navigateTo(menuItem.url, {
        external: !!menuItem.is_open_new_tab,
        open: { target: menuItem.is_open_new_tab ? '_blank' : '_self' },
      });
    },
  },
});
</script>

